<script setup>
import StartupEditField from "@/components/startups/startupEdit/StartupEditField.vue";
import {inject, onMounted, ref, watch} from "vue";
import clientsService from "@/services/clients.service";
import VueMultiselect from "vue-multiselect";

const form = inject("form");
const clients = ref(null);
const clientsList = ref([]);

watch(clients, value => {
    form.clients = value.map(item => item.id);
});

onMounted(() => {
    clients.value = form.clients;
    clientsList.value = form.clients;
});

async function updateClientsList(query) {
    const {data} = await clientsService.getList(query);
    clientsList.value = data;
}

</script>

<template>
    <div>
        <StartupEditField
            field-name="clients"
            label="Clients"
        >
            <template #input>
                <VueMultiselect
                    v-model="clients"
                    multiple
                    placeholder="Select Clients"
                    :options="clientsList"
                    select-label=""
                    deselect-label=""
                    label="name"
                    track-by="name"
                    class="multiselect-mid pl-2"
                    @search-change="updateClientsList"
                />
            </template>
        </StartupEditField>

        <StartupEditField
            field-name="features"
            label="Features"
            type="textarea"
        />

        <StartupEditField
            field-name="founder"
            label="Founder"
        />
    </div>
</template>

<style scoped>

</style>
